import { useDataLoader } from "react-remote-data-hooks";
import React, { useEffect } from "react";
import Multiselect from "react-widgets/lib/Multiselect";

const RemoteDataMultiSelectDropDown: React.FunctionComponent<{
  loadData: () => Promise<any[]>;
  value?: any;
  defaultValue?: any;
  busy?: boolean;
  onChange?: (value: any) => void;
  multiple?: boolean;
  isReload?: boolean;
  valueField?: string;
  textField?: string | ((dataItem: any) => string);
  placeholder?: string;
  itemComponent?: React.ReactType<any> | undefined;
  tagComponent?:
    | string
    | React.ComponentClass<any, any>
    | React.FunctionComponent<any>
    | undefined;
}> = (props) => {
  const { loadData, ...dropDownProps } = props;
  const { data, loading, loaded, reload } = useDataLoader(loadData);

  useEffect(() => {
    if (props?.isReload) {
      reload();
    }
  }, [props?.isReload]);

  return (
    <Multiselect
      {...dropDownProps}
      busy={props?.busy || !loaded || loading}
      data={data || []}
      filter={"contains"}
      itemComponent={props.itemComponent}
      tagComponent={props.tagComponent}
    />
  );
};

export default RemoteDataMultiSelectDropDown;
